import requirementCompletionDetailsLocale from 'modules/requirements/RequirementCompletionDetails/localization/en.json'
import requirementsLocale from 'modules/requirements/Requirements/localization/en.json'

const en = {
  requirements: requirementsLocale,
  requirementCompletionDetails: requirementCompletionDetailsLocale,
}

export default en
